import { useEffect, useState } from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { useDataGrid } from "./DataGridContext";
import { useIsSmallScreen } from "../../utils/useMediaQuery";

/**
 * Grid'in ÜSTÜNDEKİ serbest arama kutusu — yalnız dar ekranda görünür.
 *
 * Neden: mobilde filtre paneli bir çekmecede duruyor; en çok kullanılan alan (serbest arama) için
 * her seferinde çekmeceyi açmak gerekiyordu. Geniş ekranda panel zaten görünür olduğu için burada
 * ikinci bir kutu göstermiyoruz.
 *
 * Filtre paneliyle ÇİFT YÖNLÜ senkron: kutu uygulanan filtreyi (queryModel) okur, yazınca yine onu
 * günceller; paneldeki arama alanı da uygulanan değeri izlediği için ikisi hiçbir zaman ayrışmaz.
 *
 * @param windowFilterKey Uygulanan filtrenin saklandığı global anahtar ('studyFilter' / 'reportFilter').
 *                        Sayfadan çıkıp dönünce filtre oradan geri yükleniyor (bkz. StudyFilter).
 */
export default function GridSearchBar({ windowFilterKey, hint, placeholder }) {
    const { t } = useTranslation();
    const isSmallScreen = useIsSmallScreen(992);
    const { queryModel, onFilterPageSort } = useDataGrid();

    const applied = queryModel?.filter?.searchText || '';
    const [text, setText] = useState(applied);

    // Arama filtre panelinden yapıldıysa üstteki kutu da onu göstersin.
    useEffect(() => {
        setText(applied);
    }, [applied]);

    if (!isSmallScreen)
        return null;

    const apply = () => {
        const value = text?.trim();
        const filter = {
            ...(queryModel?.filter || {}),
            // Boşaltıldığında alan tamamen kalksın; boş string sunucuya gitmesin.
            searchText: value || undefined,
        };

        if (windowFilterKey)
            window[windowFilterKey] = filter;

        onFilterPageSort({ filter });
    }

    const active = !!applied;

    return (
        <div style={{
            background: active ? 'var(--accent-soft)' : 'var(--surface-2)',
            border: active ? '1px solid var(--accent)' : '1px solid var(--border)',
            borderRadius: 6,
            padding: 8,
            marginBottom: 8,
        }}>
            <div style={{
                marginBottom: 4,
                fontSize: 11,
                fontStyle: 'italic',
                color: active ? 'var(--accent-dark)' : 'var(--text-2)',
            }}>
                {hint || t('Search by patient name, ID, accession number or description - searches all dates')}
            </div>
            <Input.Search
                size={'small'}
                allowClear
                value={text}
                placeholder={placeholder || t('Type anything: name, ID, number...')}
                enterButton={t('Search')}
                onChange={(e) => setText(e.target.value)}
                // Enter'da tarayıcı davranışı yok (form içinde değiliz); tek yol onSearch.
                onSearch={apply}
            />
        </div>
    );
}
